import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";
let sms = () => import(/* webpackChunkName: "logs" */ '@/views/logs/Sms');
let activityLogs = () => import(/* webpackChunkName: "logs" */ '@/views/logs/ActivityLogs');
export default [
    ...prefix("/logs",[
        {
            path: "sms",
            name: "logs.sms",
            component: sms,
            meta: {
                middleware: web,
                permissions: ['logs:sms'],
                title: "تاریخچه پیامک"
            }
        },
        {
            path: "activity-logs",
            name: "logs.activity",
            component: activityLogs,
            meta: {
                middleware: web,
                permissions: ['logs:viewAnyActivityLogs'],
                title: "تاریخچه فعالیت"
            }
        },
        ]
    )
]